import { PromptTemplateType } from "@app/types/PromptTemplate";

export function sortPromptTemplates(templates: PromptTemplateType[]) {
    return templates.sort((a, b) => {
        if (a.name === 'Default') return -1;
        if (b.name === 'Default') return 1;
        return a.label.localeCompare(b.label, undefined, { sensitivity: 'base' });
    });
}